import constants from '@/constants/constants'
import { SMAGableExtensions } from '@/xstore/utils/smagable'

export default ({useExtension}) => {
    {
        const state = {
            form_submission: undefined
        }

        useExtension(SMAGableExtensions.SMGable, {state})
    }


    return {
        actions: {
            generateFormSubmission: ({commit}, formSourceJSON) => {
                let submission = {}

                Object.entries(formSourceJSON.fields)
                    .forEach(([fieldID, fieldObj]) => {
                        if (constants.FIELD_FROM_TYPE[fieldObj.field_type].WITH_SUBMISSION)
                            submission[fieldID] = constants.FIELD_FROM_TYPE[fieldObj.field_type].generateSubmissionObj(fieldObj)
                    })

                commit('SET_FORM_SUBMISSION', submission)
            },
            resetAfterSubmit: ({commit, parentGetters}) => {
                let submission = {}

                Object.entries(parentGetters.getFormSourceJSON.fields)
                    .forEach(([fieldID, fieldObj]) => {
                        if (constants.FIELD_FROM_TYPE[fieldObj.field_type].WITH_SUBMISSION)
                            submission[fieldID] = constants.FIELD_FROM_TYPE[fieldObj.field_type].generateSubmissionObj(fieldObj)
                    })

                commit('SET_FORM_SUBMISSION', submission)
            },
            updateFormSubmissionField: ({commit, parentDispatch, getters, parentGetters}, {fieldID, updatedSubmission}) => {
                commit('SET_FORM_SUBMISSION', {...getters.getFormSubmission, [fieldID]: updatedSubmission})
                parentDispatch('submission_metrics/formSubmissionChanged')

                
                // auto scroll for interactive forms
                {
                    if (parentGetters.isFormInteractive && parentGetters.getFormSourceJSON.settings.general_settings.auto_scroll) {
                        const fieldTypeConst = constants.FIELD_FROM_TYPE[parentGetters.getFormSourceJSON.fields[fieldID].field_type]

                        if (fieldTypeConst.AUTO_SCROLL_HANDLER && fieldTypeConst.AUTO_SCROLL_HANDLER?.(updatedSubmission, parentGetters.getFormSourceJSON.fields[fieldID]))
                           parentDispatch('goToNextPage')
                    }
                }

                // Skip logic auto-navigation for interactive forms (immediate redirect)
                {
                    if (parentGetters.isFormInteractive) {
                        const fieldObj = parentGetters.getFormSourceJSON.fields[fieldID]
                        
                        // Check if this field has skip logic configured
                        if (fieldObj?.condition?._skip_logic_data) {
                            const skipLogicData = fieldObj.condition._skip_logic_data
                            
                            // Get selected options from the updated submission
                            let selectedOptions = []
                            if (fieldObj.field_type === 'IMAGE_CHOICE') {
                                selectedOptions = updatedSubmission.selected_options || []
                            } else {
                                selectedOptions = updatedSubmission.value || []
                            }
                            
                            // Check if any selected option has a destination
                            for (const selectedIndex of selectedOptions) {
                                const destination = skipLogicData.destinations[selectedIndex]
                                if (destination) {
                                    console.log('🚀 Interactive Skip Logic Triggered:', {
                                        fieldID,
                                        selectedIndex,
                                        destination
                                    })
                                    
                                    // Handle different destination types
                                    if (destination.type === 'question' && destination.field_id) {
                                        // Regular question jump - auto-navigate immediately
                                        console.log('🚀 Interactive: Auto-navigating to question')
                                        setTimeout(() => {
                                            parentDispatch('goToNextPage')
                                        }, 500)
                                    } else if (destination.type === 'end_survey') {
                                        // End survey - auto-navigate to finish
                                        console.log('🏁 Interactive: Auto-navigating to end survey')
                                        setTimeout(() => {
                                            parentDispatch('goToNextPage')
                                        }, 500)
                                    } else if (destination.type === 'thank_you') {
                                        // Thank you page - auto-navigate to thank you
                                        console.log('💝 Interactive: Auto-navigating to thank you page')
                                        setTimeout(() => {
                                            parentDispatch('goToNextPage')
                                        }, 500)
                                    } else if (destination.type === 'redirect_url') {
                                        // Redirect URL - IMMEDIATE redirect in interactive forms
                                        console.log('🔗 Interactive: Executing immediate redirect')
                                        
                                        if (destination.redirect_url) {
                                            // Execute redirect IMMEDIATELY while user action context is preserved
                                            let normalizedUrl = destination.redirect_url.trim();
                                            if (!normalizedUrl.startsWith('https://') && !normalizedUrl.startsWith('http://')) {
                                                normalizedUrl = 'https://' + normalizedUrl;
                                            }
                                            
                                            try {
                                                // Use window.location.href to redirect in the same tab
                                                window.location.href = normalizedUrl;
                                            } catch (error) {
                                                alert(`No se pudo redirigir automáticamente. Por favor, visita: ${normalizedUrl}`);
                                            }
                                        }
                                    } else if (destination.field_id) {
                                        // Legacy format (no type specified) - treat as question
                                        console.log('🚀 Interactive: Auto-navigating to question (legacy)')
                                        setTimeout(() => {
                                            parentDispatch('goToNextPage')
                                        }, 500)
                                    }
                                    
                                    break // Use the first matching destination
                                }
                            }
                        }
                        // Check for traditional conditional logic with jump_to in interactive forms
                        else if (fieldObj?.condition?.if_target?.action === 'jump_to') {
                            console.log('🔍 Interactive: Checking traditional conditional logic for field:', fieldID, {
                                condition: fieldObj.condition,
                                updatedSubmission
                            })
                            
                            try {
                                const constants = require('@/constants/constants').default
                                const conditionalResult = constants.FIELD_FROM_TYPE[fieldObj.field_type].CONDITIONAL_LOGIC.VALIDATE(
                                    fieldObj.condition, 
                                    updatedSubmission, 
                                    fieldObj
                                )
                                
                                console.log('🔍 Interactive: Conditional Logic Validation Result:', {
                                    fieldID,
                                    conditionalResult,
                                    destinationFieldId: fieldObj.condition.if_target.field_id
                                })
                                
                                if (conditionalResult) {
                                    console.log('🚀 Interactive: Auto Conditional Logic Triggered')
                                    
                                    // Automatically navigate to the destination page
                                    setTimeout(() => {
                                        parentDispatch('goToNextPage')
                                    }, 500)
                                }
                            } catch (error) {
                                console.warn('Error validating conditional logic in interactive form:', error)
                            }
                        }
                    }
                }

                // Skip logic auto-navigation for static forms (redirect waits for Next button)
                {
                    if (parentGetters.isFormStatic) {
                        const fieldObj = parentGetters.getFormSourceJSON.fields[fieldID]
                        
                        // Check if this field has skip logic configured
                        if (fieldObj?.condition?._skip_logic_data) {
                            const skipLogicData = fieldObj.condition._skip_logic_data
                            
                            // Get selected options from the updated submission
                            let selectedOptions = []
                            if (fieldObj.field_type === 'IMAGE_CHOICE') {
                                selectedOptions = updatedSubmission.selected_options || []
                            } else if (fieldObj.field_type === 'STAR_RATING') {
                                // StarRating uses a single numeric value, convert to array for consistency
                                selectedOptions = updatedSubmission.value !== null ? [updatedSubmission.value] : []
                            } else {
                                selectedOptions = updatedSubmission.value || []
                            }
                            
                            // Check if any selected option has a destination
                            for (const selectedIndex of selectedOptions) {
                                const destination = skipLogicData.destinations[selectedIndex]
                                if (destination) {
                                    console.log('🚀 Auto Skip Logic Triggered:', {
                                        fieldID,
                                        selectedIndex,
                                        destination
                                    })
                                    
                                    // Handle different destination types
                                    if (destination.type === 'question' && destination.field_id) {
                                        // Regular question jump - in static forms, don't auto-navigate
                                        // The navigation will be handled when user clicks "Next" button
                                        console.log('🎯 Static Skip Logic: Question jump configured (will execute on Next click)')
                                        
                                        // Only handle same-page scrolling immediately for better UX
                                        const currentPageID = parentGetters.getCurrentPageID
                                        const fieldsGroupedByPages = parentGetters.getFieldsGroupedByPages
                                        let targetPageId = null
                                        
                                        // Find which page contains the target field
                                        for (const [pageId, fieldIds] of Object.entries(fieldsGroupedByPages)) {
                                            if (fieldIds.includes(destination.field_id)) {
                                                targetPageId = pageId
                                                break
                                            }
                                        }
                                        
                                        if (targetPageId === currentPageID) {
                                            // Target is on same page - scroll to it immediately for better UX
                                            console.log('🔄 Static: Target on same page, scrolling immediately')
                                            setTimeout(() => {
                                                parentDispatch('scrollToField', destination.field_id)
                                            }, 300)
                                        }
                                    } else if (destination.type === 'end_survey') {
                                        // End survey - in static forms, don't auto-navigate
                                        // The navigation will be handled when user clicks "Next" button
                                        console.log('🏁 Static Skip Logic: End survey configured (will execute on Next click)')
                                    } else if (destination.type === 'thank_you') {
                                        // Thank you page - in static forms, don't auto-navigate
                                        // The navigation will be handled when user clicks "Next" button
                                        console.log('💝 Static Skip Logic: Thank you page configured (will execute on Next click)')
                                    } else if (destination.type === 'redirect_url') {
                                        // Redirect URL - in static forms, don't auto-navigate
                                        // The redirect will be handled when user clicks "Next" button
                                        console.log('🔗 Static Skip Logic: Redirect URL configured (will execute on Next click)')
                                    } else if (destination.field_id) {
                                        // Legacy format (no type specified) - in static forms, don't auto-navigate
                                        // The navigation will be handled when user clicks "Next" button
                                        console.log('🎯 Static Skip Logic: Question jump configured - legacy (will execute on Next click)')
                                        
                                        // Only handle same-page scrolling immediately for better UX
                                        const currentPageID = parentGetters.getCurrentPageID
                                        const fieldsGroupedByPages = parentGetters.getFieldsGroupedByPages
                                        let targetPageId = null
                                        
                                        // Find which page contains the target field
                                        for (const [pageId, fieldIds] of Object.entries(fieldsGroupedByPages)) {
                                            if (fieldIds.includes(destination.field_id)) {
                                                targetPageId = pageId
                                                break
                                            }
                                        }
                                        
                                        if (targetPageId === currentPageID) {
                                            // Target is on same page - scroll to it immediately for better UX
                                            console.log('🔄 Static: Target on same page, scrolling immediately (legacy)')
                                            setTimeout(() => {
                                                parentDispatch('scrollToField', destination.field_id)
                                            }, 300)
                                        }
                                    }
                                    
                                    break // Use the first matching destination
                                }
                            }
                        }
                        // Check for traditional conditional logic with jump_to
                        else if (fieldObj?.condition?.if_target?.action === 'jump_to') {
                            console.log('🔍 Static: Checking traditional conditional logic for field:', fieldID, {
                                condition: fieldObj.condition,
                                updatedSubmission
                            })
                            
                            try {
                                const constants = require('@/constants/constants').default
                                const conditionalResult = constants.FIELD_FROM_TYPE[fieldObj.field_type].CONDITIONAL_LOGIC.VALIDATE(
                                    fieldObj.condition, 
                                    updatedSubmission, 
                                    fieldObj
                                )
                                
                                console.log('🔍 Static: Conditional Logic Validation Result:', {
                                    fieldID,
                                    conditionalResult,
                                    destinationFieldId: fieldObj.condition.if_target.field_id
                                })
                                
                                if (conditionalResult) {
                                    console.log('🎯 Static: Traditional conditional logic configured (will execute on Next click):', {
                                        fieldID,
                                        destinationFieldId: fieldObj.condition.if_target.field_id
                                    })
                                    
                                    // In static forms, don't auto-navigate
                                    // The navigation will be handled when user clicks "Next" button
                                }
                            } catch (error) {
                                console.warn('Error validating conditional logic in static form:', error)
                            }
                        }
                    }
                }
            },
        }
    }
}